module.exports = __webpack_public_path__ + "img/timg.5d240186.gif";